import * as moment from "moment";
export const utils = {
  isNil(value: any): boolean {
    return value === null || value === undefined;
  },

  isEmptyValue(value: any): boolean {
    return (
      this.isNil(value) ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    );
  },

  /**
   * Converts dropdown/input values into a nullable number.
   *
   * BackOffice selectors use an empty string to represent "None", while API
   * payloads and component state use `null` for the same meaning. Keeping the
   * conversion here prevents each component from repeating that guard logic.
   */
  toNullableNumber(value: number | string | null | undefined): number | null {
    if (this.isEmptyValue(value)) {
      return null;
    }

    const parsedValue = Number(value);
    return Number.isNaN(parsedValue) ? null : parsedValue;
  },

  /**
   * Formats a date-time value into `YYYY-MM-DD hh:mm A` format.
   *
   * @param value The date-time string to format.
   * @returns The formatted date-time string, or an empty string if the value is not provided.
   */
  formatDateTime(value: string): string {
    return value ? moment(value).format("YYYY-MM-DD hh:mm A") : "";
  },

  /**
   * Sorts an array of response objects by the specified numeric key in ascending order.
   *
   * @param {Array<Object>} response - Array of objects to sort.
   * @param {string} key - Object property used for sorting.
   * @returns {Array<Object>} The sorted array.
   */

  sortArrayOfObjectsByKey(response: Array<Object>, key: string): any {
    return response.sort((a, b) => a[key] - b[key]);
  },
};
